"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.weeklyTabs = exports.typeStringMapLong = exports.typeStringMap = exports.taetigkeitTypes = exports.nachweisTypes = exports.monthlyTabsLong = exports.monthlyTabs = exports.isWeeklyType = exports.isTypWithQualification = exports.isMonthlyType = exports.getTabsForNachweisTypeLongNames = exports.getTabsForNachweisType = exports.getAttachmentLimitPerGroup = exports.dailyTabsLong = exports.dailyTabs = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var nachweisTypes = exports.nachweisTypes = {
  WEEKLY: 'weekly',
  DAILY: 'daily',
  MONTHLY: 'monthly',
  WEEKLY_WITH_QUALIFICATION: 'weekly_with_qualification',
  DAILY_WITH_QUALIFICATION: 'daily_with_qualification'
};
var taetigkeitTypes = exports.taetigkeitTypes = {
  MONDAY: 'monday',
  TUESDAY: 'tuesday',
  WEDNESDAY: 'wednesday',
  THURSDAY: 'thursday',
  FRIDAY: 'friday',
  SATURDAY: 'saturday',
  WORK: 'work',
  TRAINING: 'training',
  SCHOOL: 'school',
  MONTH: 'month'
};
var dailyTypes = [taetigkeitTypes.MONDAY, taetigkeitTypes.TUESDAY, taetigkeitTypes.WEDNESDAY, taetigkeitTypes.THURSDAY, taetigkeitTypes.FRIDAY, taetigkeitTypes.SATURDAY];
var weeklyTypes = [taetigkeitTypes.WORK, taetigkeitTypes.TRAINING, taetigkeitTypes.SCHOOL];
var monthlyTypes = [taetigkeitTypes.MONTH];
var typeStringMap = exports.typeStringMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, taetigkeitTypes.MONDAY, 'nachweis_edit_tab_montag'), taetigkeitTypes.TUESDAY, 'nachweis_edit_tab_dienstag'), taetigkeitTypes.WEDNESDAY, 'nachweis_edit_tab_mittwoch'), taetigkeitTypes.THURSDAY, 'nachweis_edit_tab_donnerstag'), taetigkeitTypes.FRIDAY, 'nachweis_edit_tab_freitag'), taetigkeitTypes.SATURDAY, 'nachweis_edit_tab_samstag'), taetigkeitTypes.WORK, 'nachweis_edit_tab_arbeit'), taetigkeitTypes.TRAINING, 'nachweis_edit_tab_schulungen'), taetigkeitTypes.SCHOOL, 'nachweis_edit_tab_schule'), taetigkeitTypes.MONTH, 'nachweis_edit_tab_contents');
var typeStringMapLong = exports.typeStringMapLong = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, taetigkeitTypes.MONDAY, 'nachweis_edit_tab_montag_long'), taetigkeitTypes.TUESDAY, 'nachweis_edit_tab_dienstag_long'), taetigkeitTypes.WEDNESDAY, 'nachweis_edit_tab_mittwoch_long'), taetigkeitTypes.THURSDAY, 'nachweis_edit_tab_donnerstag_long'), taetigkeitTypes.FRIDAY, 'nachweis_edit_tab_freitag_long'), taetigkeitTypes.SATURDAY, 'nachweis_edit_tab_samstag_long'), taetigkeitTypes.WORK, 'nachweis_edit_tab_arbeit'), taetigkeitTypes.TRAINING, 'nachweis_edit_tab_schulungen'), taetigkeitTypes.SCHOOL, 'nachweis_edit_tab_schule'), taetigkeitTypes.MONTH, 'nachweis_edit_tab_contents');
var dailyTabs = exports.dailyTabs = dailyTypes.map(function (i) {
  return {
    index: i,
    titleKey: typeStringMap[i.toString()]
  };
});
var dailyTabsLong = exports.dailyTabsLong = dailyTypes.map(function (i) {
  return {
    index: i,
    titleKey: typeStringMapLong[i.toString()]
  };
});
var weeklyTabs = exports.weeklyTabs = weeklyTypes.map(function (i) {
  return {
    index: i,
    titleKey: typeStringMap[i.toString()]
  };
});
var monthlyTabs = exports.monthlyTabs = monthlyTypes.map(function (i) {
  return {
    index: i,
    titleKey: typeStringMap[i.toString()]
  };
});
var monthlyTabsLong = exports.monthlyTabsLong = monthlyTypes.map(function (i) {
  return {
    index: i,
    titleKey: typeStringMapLong[i.toString()]
  };
});
var getTabsForNachweisType = exports.getTabsForNachweisType = function getTabsForNachweisType(type) {
  switch (type) {
    case nachweisTypes.WEEKLY:
    case nachweisTypes.WEEKLY_WITH_QUALIFICATION:
      return weeklyTabs;
    case nachweisTypes.DAILY:
    case nachweisTypes.DAILY_WITH_QUALIFICATION:
      return dailyTabs;
    case nachweisTypes.MONTHLY:
      return monthlyTabs;
    default:
      return [];
  }
};
var getTabsForNachweisTypeLongNames = exports.getTabsForNachweisTypeLongNames = function getTabsForNachweisTypeLongNames(type) {
  switch (type) {
    case nachweisTypes.WEEKLY:
    case nachweisTypes.WEEKLY_WITH_QUALIFICATION:
      return weeklyTabs;
    case nachweisTypes.DAILY:
    case nachweisTypes.DAILY_WITH_QUALIFICATION:
      return dailyTabsLong;
    case nachweisTypes.MONTHLY:
      return monthlyTabsLong;
    default:
      return [];
  }
};
var isWeeklyType = exports.isWeeklyType = function isWeeklyType(type) {
  switch (type) {
    case nachweisTypes.WEEKLY:
    case nachweisTypes.WEEKLY_WITH_QUALIFICATION:
    case nachweisTypes.DAILY:
    case nachweisTypes.DAILY_WITH_QUALIFICATION:
      return true;
    default:
      return false;
  }
};
var isMonthlyType = exports.isMonthlyType = function isMonthlyType(type) {
  switch (type) {
    case nachweisTypes.MONTHLY:
      return true;
    default:
      return false;
  }
};
var isTypWithQualification = exports.isTypWithQualification = function isTypWithQualification(type) {
  switch (type) {
    case nachweisTypes.WEEKLY_WITH_QUALIFICATION:
    case nachweisTypes.DAILY_WITH_QUALIFICATION:
      return true;
    default:
      return false;
  }
};
var getAttachmentLimitPerGroup = exports.getAttachmentLimitPerGroup = function getAttachmentLimitPerGroup(type) {
  if (isMonthlyType(type)) {
    return 20;
  }
  return 5;
};